import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import { LanguageProvider } from "./i18n/LanguageContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

import Home from "./pages/Home";
import Method from "./pages/Method";
import About from "./pages/About";
import Curriculum from "./pages/Curriculum";
import Resources from "./pages/Resources";
import Contact from "./pages/Contact";
import PillarPage from "./pages/PillarPage";

function App() {
  return (
    <div className="App min-h-screen bg-[#F8F7F2]">
      <LanguageProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/method" element={<Method />} />
              <Route path="/body" element={<PillarPage pillar="body" />} />
              <Route path="/mind" element={<PillarPage pillar="mind" />} />
              <Route path="/spirit" element={<PillarPage pillar="spirit" />} />
              <Route path="/curriculum" element={<Curriculum />} />
              <Route path="/about" element={<About />} />
              <Route path="/resources" element={<Resources />} />
              <Route path="/contact" element={<Contact />} />
              {/* Legacy redirects from older URLs */}
              <Route path="/shop" element={<Navigate to="/curriculum" replace />} />
              <Route path="/programs" element={<Navigate to="/curriculum" replace />} />
              <Route path="/institutions" element={<Navigate to="/contact" replace />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </main>
          <Footer />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
